import React from 'react';
import ApolloError from '@shared/components/ApolloError';
import ReportDataMapper from '../../../mappers/ReportDataMapper';
import TotalReportTable from './totalReportTable';
import { useQuery } from '@apollo/client';
import GET_FDA_CONTRACT_TOTAL_REPORT from '../../../queries/getFdaContractTotalReportQuery';

/**
 * @typedef {object} SACTotalViewProps
 * @property {Array<number>} ohts
 * @property {number} [orgId]
 */

/**
 * @param {SACTotalViewProps} props
 */
const SACTotalView = props => {
  const { ohts, orgId } = props;

  const {
    data: totalData,
    loading: totalDataLoading,
    error: totalDataError
  } = useQuery(GET_FDA_CONTRACT_TOTAL_REPORT, {
    variables: { ohts, orgId }
  });

  const totalReportData = totalData?.fdaContractTotalReport.map(
    ReportDataMapper.mapFdaPracticeArea
  );

  if (totalDataError) {
    return <ApolloError />;
  }

  return <TotalReportTable loading={totalDataLoading} data={totalReportData} />;
};

export default SACTotalView;
